import { getCookie } from 'utilities/helper';
import translationDE from './de/translation.json';
import translationENUS from './en-US/translation.json';
import { DEFAULT_LANGUAGE_CODE } from 'constants/common.constants';
var appLanguageResources: any = {
  en: { translation: translationENUS },
  de: { translation: translationDE },
};

// customization of translation code
const getTranslationURL = (locale: string) => {
  let url = `${window.location.origin}/app/analytics/languages/${locale}.json`;
  url = url.replace(
    /payanalytics.kornferrytalent/g,
    'translations.kornferrytalent',
  );
  return url;
};

const fetchTranslations = async (locale: string) => {
  const translationURL = getTranslationURL(locale);
  const response = await fetch(translationURL);
  if (!response.ok) {
    throw new Error(`Failed to fetch translation: ${response.status}`);
  }
  return (await response.json()) as Record<string, any>;
};

export const getLanguages = async (languageValue?: string | null): Promise<any> => {
  try {
    const currentLanguage: any = getCookie('__kfone_i18n_primary_lng');
    let langCode = languageValue?.trim() || currentLanguage || DEFAULT_LANGUAGE_CODE;
    langCode = langCode.replace(/_/g, '-');
    const shortLangCode = getShortLocale(langCode);
   sessionStorage.setItem('kfone_short_lang_code', shortLangCode);
    // Wait for BOTH English + selected language, 
    const [enTranslations, selectedTranslations] = await Promise.all([
      fetchTranslations(DEFAULT_LANGUAGE_CODE),
      shortLangCode === DEFAULT_LANGUAGE_CODE ? Promise.resolve({}) : fetchTranslations(shortLangCode),
    ]);
    const translations  = { ...enTranslations, ...selectedTranslations };


    return {
      en: { translation: translations },
      de: { translation: translations },
    };
  } catch (error) {
    return {
      en: { translation: translationENUS },
      de: { translation: translationDE },
    };
  }
};

const LOCALE_OVERRIDES: Record<string, string> = {
  'en-US': DEFAULT_LANGUAGE_CODE,
  'pt-PT': 'pt',
  'es-XL': 'es-AR',
  'fr-FR': 'fr',
  'no-NO': 'no-NO',
};

const KEEP_FULL_PREFIXES = ['pt', 'fr', 'es', 'en-'];

const getShortLocale = (locale: string): string => {
  try{
  const override = LOCALE_OVERRIDES[locale];
  if (override !== undefined) return override;
  if (KEEP_FULL_PREFIXES.some((prefix) => locale.startsWith(prefix))) return locale;
  return locale.slice(0, 2).toLowerCase();
  } catch (error) {
    console.error('Error getting short locale:', error);
    return DEFAULT_LANGUAGE_CODE;
  }
};

export default appLanguageResources;
